<template>
  <div class="login-container">
    <div class="login-weaper animated bounceInDown">
      <div class="login-border">
        <div class="login-main">
          <h4 class="login-title">登录</h4>
          <el-form
            class="login-form"
            :rules="loginRules"
            ref="loginForm"
            :model="loginForm"
            @keyup.enter.native="handleLogin()"
            label-width="0">
            <el-form-item prop="name">
              <el-input
                size="small"
                v-model="loginForm.name"
                auto-complete="off"
                @blur="handleGetUserInfo"
                placeholder="用户名">
                  <i slot="prefix" class="el-icon-user"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="pass">
              <el-input
                size="small"
                v-model="loginForm.pass"
                :type="passwordType"
                auto-complete="off"
                placeholder="密码">
                <i
                  class="el-icon-view el-input__icon"
                  slot="suffix"
                  @click="showPassword"></i>
                <i slot="prefix" class="el-icon-lock"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="smsCode" v-if="isShowcaptcha">
              <div class="input-captcha">
                <el-input
                size="small"
                v-model="loginForm.smsCode"
                auto-complete="off"
                :maxlength="6"
                :max="6"
                placeholder="验证码">
                <i slot="prefix" class=" fa fa-envelope-o"></i>
              </el-input>
              <div class="captcha" :style="{color: disabledLoginCapture ? '#ccc': '#409eff'}" @click="handleGetCaptcha">{{disabledLoginCapture ? `重新获取(${time}s)`
          : '获取验证码'}}</div>
              </div>
                <!-- <span slot="append">获取验证码</span> -->
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                size="small"
                :loading="submitLoading"
                @click.native.prevent="handleLogin"
                class="login-submit">
                登录
              </el-button>
            </el-form-item>
            <!-- <el-form-item>
              <el-button
                type="primary"
                size="small"
                @click.native.prevent="handleRegister"
                class="login-submit">
                注册
              </el-button>
            </el-form-item> -->
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { mapState } from "vuex";
import { Message } from 'element-ui'

export default {
  components: {},
  data() {
    return {
      loginForm: {
        // userName: '',
        name: '',
        // password: "",
        // userPassword: ''
        pass: '',
      },
      code: '',
      language: 'zh',
      passwordType: 'password',
      submitLoading: false,
      loginRules: {
        name: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        pass: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        smsCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      isShowcaptcha: false,
      disabledLoginCapture: false,
      time: 60
    }
  },
  watch: {},
  created() {
  },
  mounted() {
    sessionStorage.clear()
    localStorage.clear()
    this.resetStore()
  },
  computed: {},
  methods: {
    // 重置store
    resetStore() {
      this.$store.commit('setNavTree', {})
    },
    // 是否展示密码
    showPassword() {
      this.passwordType == 'text'
        ? (this.passwordType = 'password')
        : (this.passwordType = 'text')
    },
    // 登录
    handleLogin() {
      const _t = this
      _t.$refs['loginForm'].validate((valid) => {
        if (valid) {
          _t.submitLoading = true
          _t.$api.login.mLogin(this.loginForm).then((res) => {
            _t.submitLoading = false
            if (res.code === '0') {
              _t.$message({ message: '登录成功', type: 'success' })
              // 缓存token
              localStorage.setItem('token', res.data.token)
              localStorage.setItem('loginStaffId', res.data.staffId)
              localStorage.setItem('coalMineNo', res.data.coalMineNo)
              localStorage.setItem('phone', res.data.phone)
              localStorage.setItem('name', res.data.name)
              localStorage.setItem('phone', res.data.phone)
              localStorage.setItem('companyName', res.data.companyName)
              localStorage.setItem('companyShortName', res.data.companyShortName)
              localStorage.setItem('navTreeData', JSON.stringify(res.data.funcPermissionDTOList))
              _t.$refs['loginForm'].resetFields()
              _t.$store.commit('menuRouteLoaded', false) // 要求重新加载导航菜单
              _t.$router.push('/transition') // 登录成功，跳转到主页
            } else {
              _t.submitLoading = false
              _t.$message({
                message: '登录失败, ' + res.message,
                type: 'error'
              })
            }
          }).catch(err => {
            _t.submitLoading = false
          })
        }
      })
    },
    // 注册
    handleRegister() {
      const _t = this
      _t.$router.push({ path: '/register' })
    },
    async handleGetUserInfo(){
      if(!this.loginForm.name) {
        this.isShowcaptcha = false
        return
      }
      let res= await this.$api.login.loginCheck({
        name: this.loginForm.name
      })
      this.isShowcaptcha = res.data.loginVerifyStatus 
    },
    async handleGetCaptcha(){
      if(this.disabledLoginCapture) return
      let res = await this.$api.login.mGetSmsCode({
        name: this.loginForm.name
      })
      this.disabledLoginCapture = true
      this.countdown()
    },
    countdown(){
      if(this.time ==0){
        this.time = 0
        this.disabledLoginCapture = false
        return
      }
      setTimeout(() => {
        this.time-- 
        this.countdown()
      }, 1000);

    }
  }
}
</script>

<style lang="scss">
  @import "../styles/login.scss";
</style>

<style lang="scss" scoped>
.input-captcha {
  width: 100%;
  position: relative;
  .captcha {
    position: absolute;
    right: 10px;
    top: 0;
    color: #409eff;
    cursor: pointer;
    font-size: 14px;
  }
}
</style>
